<template>
    <div class="mt-5">
        <vs-tabs alignment="fixed">
            <vs-tab label="Timekeeping" icon-pack="feather" icon="icon-clock">
              <vx-card title="Pending Approvals - Timekeeping" subtitle="Lists of time logs for approval"  class="app-fixed-height">
            
                <div class="vx-col w-full mb-base">
                  <!-- <template>
                      <vs-table stripe>
                          <template slot="thead">
                            <vs-th>DATE</vs-th>
                            <vs-th>TYPE</vs-th>
                            <vs-th>TIME-IN</vs-th>
                            <vs-th>TIME-OUT</vs-th>
                            <vs-th>REASON</vs-th>
                            <vs-th>ATTACHMENT</vs-th>
                            <vs-th>STATUS</vs-th>
                            <vs-th>ACTION</vs-th>
                          </template>
                    </vs-table>
                  </template> -->
                </div>
              </vx-card>
            
            

            </vs-tab>
<!-- END TIMEKEEPING -->
<!-- LEAVE MANAGEMENT -->

            <vs-tab label="Leaves" icon-pack="feather" icon="icon-calendar">
              <vx-card  title="Pending Approvals - Leaves" subtitle="Leave Request for approval"  class="app-fixed-height">
            
                <div class="vx-col w-full mb-base">
                  <pending-leave-approvals></pending-leave-approvals>
                 
                </div>
              </vx-card>
            </vs-tab>
<!-- END LEAVE MANAGEMENT  -->
<!-- OVERTIME -->

            <vs-tab label="Overtime" icon-pack="feather" icon="icon-calendar">
              <vx-card  title="Pending Approvals - Overtime" subtitle="Overtime Request for approval"  class="app-fixed-height">
                <div class="vx-col w-full mb-base">
                  <pending-overtime-approvals></pending-overtime-approvals>
                  
                </div>
              </vx-card>
            </vs-tab>
<!-- END OVERTIME  -->
<!-- LOANS -->
            <vs-tab label="Loans" icon-pack="feather" icon="icon-credit-card">
                <vx-card title="Pending Approvals - Loans" subtitle="Loan Request for approval"  class="app-fixed-height">
                  <div class="vx-col w-full mb-base">
                    <pending-loan-approvals></pending-loan-approvals>
                  </div>
              </vx-card>
            </vs-tab>
<!-- END LOANS -->
<!-- REQUEST FORMS -->
            <vs-tab label="Pending Claims" icon-pack="feather" icon="icon-package">
                <vx-card title="Pending Approvals - Claims" subtitle="Claims Request for approval"  class="app-fixed-height">
                  <div class="vx-col w-full mb-base">
                    <pending-claims-approvals></pending-claims-approvals>
                  </div>
                </vx-card>
            </vs-tab>
        </vs-tabs>
<!-- END REQUEST FORMS -->
    </div>
</template>
<script>
import PendingLeaveApprovals from './requestapprovals/PendingLeaveApprovals'
import PendingOvertimeApprovals from './requestapprovals/PendingOvertimeApprovals'
import PendingLoanApprovals from './requestapprovals/PendingLoanApprovals'
import PendingClaimsApprovals from './requestapprovals/PendingClaimsApprovals'
export default {
  components: {
    PendingLeaveApprovals,
    PendingOvertimeApprovals,
    PendingLoanApprovals,
    PendingClaimsApprovals
  },

}
</script>


